import { createWebHistory, createRouter } from "vue-router";
import HelloWorld from '@/components/HelloWorld'
import InsidentForm from './../views/InsidentForm.vue'
//import RequestForm from './../views/RequestForm.vue'
const routes = [
  {
    path: "/",
    name: "HelloWorld",
    meta: { title: 'XT Servicedesk' },
    component: HelloWorld,
  },
  {
    path: "/:client_id/ticket-form",
    name: "InsidentForm",
    meta: { title: 'XT Servicedesk' },
    component: InsidentForm,
  },
  /* {
    path: "/:client_id/request-form",
    name: "RequestForm",
    component: RequestForm,
  }, */
];

const router = createRouter({
  history: createWebHistory('/'),
  base: "./",
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

export default router;